import styled from '@emotion/styled';
import { theme, NestedMenuItem } from '@ublend-npm/aulaui-next';

export const MenuItem = styled(NestedMenuItem)`
  font-family: ${theme.font.family.workSans};
  height: 58px;
  padding: 0 ${theme.spacing.small};
  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.color.designSystem.background.grey.hover};
  }
  &:hover {
    background: ${theme.color.grey15};
  }
`;

export const MenuItemInner = styled('div')`
  display: flex;
  align-items: center;
`;

export const Title = styled('div')`
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.color.designSystem.blackOpacity87};
`;

export const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-right: ${theme.spacing.xSmall};
`;

export const SubTitle = styled('div')`
  font-size: ${theme.font.size.small};
  line-height: 16px;
  color: ${theme.color.designSystem.blackOpacity60};
`;

export const ContentWrapper = styled('div')`
  width: 353px;
  height: 42px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
